import {FiPlus} from "react-icons/fi";

import {Button} from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";

interface VaultListActionsProps {
  setShowAddModal: (v: boolean) => void;
}

export const VaultListActions = ({setShowAddModal}: VaultListActionsProps) => {
  const {user} = useCurrentUserContext();
  return (
    <div className="d-flex align-items-center">
      {user?.has_write_access && (
        <Button size={"large"} className="ms-3" onClick={() => setShowAddModal(true)}>
          <Icon icon={FiPlus} /> Create Credential
        </Button>
      )}
    </div>
  );
};
